export default "__VITE_ASSET__QnODQWHj__"